import {
  AuthenticationDetails,
  CognitoUser,
  CognitoUserPool,
  type CognitoUserSession,
} from 'amazon-cognito-identity-js'

import { ApiError } from '@/api/errors'
import type { Session } from '@/api/types'

/**
 * Login diretto contro Cognito: il frontend non passa da un backend
 * intermedio per autenticarsi, riceve il JWT e lo allega alle chiamate
 * successive verso i moduli Lambda.
 */
const userPool = new CognitoUserPool({
  UserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID as string,
  ClientId: import.meta.env.VITE_COGNITO_CLIENT_ID as string,
})

export function cognitoLogin(input: { username: string; password: string }): Promise<Session> {
  const cognitoUser = new CognitoUser({ Username: input.username, Pool: userPool })
  const authDetails = new AuthenticationDetails({
    Username: input.username,
    Password: input.password,
  })

  return new Promise((resolve, reject) => {
    cognitoUser.authenticateUser(authDetails, {
      onSuccess: (result: CognitoUserSession) => {
        resolve({
          token: result.getIdToken().getJwtToken(),
          user: { username: input.username },
        })
      },
      onFailure: (err: unknown) => reject(toApiError(err)),
      // Capita solo per un account creato con password temporanea: qui non
      // c'è UI per il cambio password, va impostata una permanente da console
      // prima del primo login.
      newPasswordRequired: () => {
        reject(
          new ApiError(
            'invalid_credentials',
            'Password temporanea: va sostituita con una permanente prima di poter accedere.',
            400,
          ),
        )
      },
    })
  })
}

export function cognitoLogout(): void {
  userPool.getCurrentUser()?.signOut()
}

function toApiError(err: unknown): ApiError {
  const code = (err as { code?: string } | null)?.code
  if (code === 'NotAuthorizedException' || code === 'UserNotFoundException') {
    return new ApiError('invalid_credentials', 'Utente o password non corretti.', 401)
  }
  return new ApiError('network', 'Impossibile contattare il servizio di autenticazione.', 0)
}
